import { zcRobots } from '@/AIChart/components/RichInput/fastQuestion';
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ChatContextType {
  skillType: string | null;
  setSkillType: (type: string | null) => void;
  isDataAnalysisMode: boolean;
  toggleDataAnalysisMode: () => void;
}

const initialContext: ChatContextType = {
  skillType: null,
  setSkillType: () => {},
  isDataAnalysisMode: true,
  toggleDataAnalysisMode: () => {},
};

const ChatContext = createContext<ChatContextType>(initialContext);

export const ChatProvider: React.FC<{children: ReactNode; robotCode: string}> = ({ children, robotCode }) => {
  // 初始化时检查robot是否属于政策机器人
  const isInZcRobots = zcRobots.includes(robotCode);
  const [skillType, setSkillType] = useState<string | null>(isInZcRobots ? 'DATA_ANALYSIS' : null);
  const [isDataAnalysisMode, setIsDataAnalysisMode] = useState(isInZcRobots);
  const toggleDataAnalysisMode = () => {
    const newMode = !isDataAnalysisMode;
    setIsDataAnalysisMode(newMode);
    setSkillType(newMode ? 'DATA_ANALYSIS' : null);
  };

  const value = {
    skillType,
    setSkillType,
    isDataAnalysisMode,
    toggleDataAnalysisMode,
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
};
